module.exports = __webpack_public_path__ + "static/media/super-spade.51b7f25e.svg";